import styled from 'styled-components';

export const MenuContentContainer = styled.div`
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  padding: 35px;

  margin-top: ${({ theme }) => theme.desktop.header.height}px;
  margin-left: ${({ theme }) => theme.desktop.menu.itemWidth}px;
`;
